import api from '../api/instance';
 
import { HelpPreference } from '@models/help-preference.model';
import { PrivateURLConstants } from '@constants/private-url.constant';
const nameSpace = PrivateURLConstants.HELP_PREFERENCES;

const show = (userId: number) => {
  return api
    .get<HelpPreference>(nameSpace + '/' + userId)
    .then((data) => new HelpPreference().deserialize(data))
    .catch((e) => Promise.reject(e));
};

const save = (helpPreference: HelpPreference) => {
  return api
    .put<HelpPreference>(
      nameSpace + '/' + helpPreference.userId,
      helpPreference.serialize(),
    )
    .then((data) => new HelpPreference().deserialize(data))
    .catch((e) => Promise.reject(e));
};
const HelpPreferenceService = {
  show,
  save,
};

export default HelpPreferenceService;
